/* Fabric Alex desktop PDP — gallery safety and desktop purchase controls. */
(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;
  if (!window.matchMedia('(min-width: 801px)').matches) return;

  var isBg = (document.documentElement.lang || '').toLowerCase().indexOf('bg') === 0;

  function installStyles() {
    if (document.getElementById('fa-product-desktop-v2-refinements')) return;
    var style = document.createElement('style');
    style.id = 'fa-product-desktop-v2-refinements';
    style.textContent = [
      '@media (min-width:801px){',
      'body.template-product .fa-product-purchase .card__separator{margin:10px 0 0!important}',
      'body.template-product .fa-commerce-product-form .product-form__info-item--price{padding:9px 0 9px!important}',
      'body.template-product .fa-commerce-product-form>.product-form__variants{padding:11px 0 11px!important}',
      '.template-product .product-meta__reference{display:flex!important;align-items:center!important;flex-wrap:wrap!important;gap:8px!important}',
      '.template-product .product-meta__sku{display:inline-flex!important;align-items:center!important;color:#657587!important;font-size:11px!important;font-weight:750!important;white-space:nowrap!important}',
      '.template-product .product-meta__sku:before{content:"";width:1px;height:13px;margin-right:8px;background:rgba(11,49,85,.18)}',
      '.template-product .product-meta__sku[hidden]{display:none!important}',
      'body.template-product .fa-commerce-product-form .color-swatch-list--large,body.template-product .fa-commerce-product-form .variant-swatch-list{display:grid!important;width:100%!important;grid-template-columns:repeat(6,minmax(0,1fr))!important;align-items:center!important;justify-items:center!important;gap:10px 6px!important;overflow:visible!important;margin:0!important;padding:4px 0 5px!important}',
      'body.template-product .fa-commerce-product-form .color-swatch,body.template-product .fa-commerce-product-form .variant-swatch{width:46px!important;height:46px!important;min-width:46px!important;margin:0!important}',
      'body.template-product .fa-commerce-product-form .color-swatch__item,body.template-product .fa-commerce-product-form .variant-swatch__item{width:42px!important;height:42px!important;min-width:42px!important;min-height:42px!important;margin:2px!important;overflow:hidden!important;border:1px solid rgba(19,44,68,.12)!important;border-radius:50%!important;background-color:#f4f1eb!important;background-size:cover!important;background-position:center!important;box-shadow:none!important;transform:none!important}',
      '.template-product .color-swatch__item{background-size:cover!important;background-position:center!important;background-repeat:no-repeat!important}',
      '.template-product .variant-swatch__item{position:relative!important}',
      'body.template-product .fa-commerce-product-form .color-swatch__radio:checked+.color-swatch__item,body.template-product .fa-commerce-product-form .variant-swatch__radio:checked+.variant-swatch__item{border-color:#0b3155!important;transform:scale(.94)!important;box-shadow:0 0 0 3px #fff,0 0 0 5px #0b3155!important}',
      '.template-product .variant-swatch__item .aspect-ratio{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;padding:0!important;overflow:hidden!important;border-radius:50%!important}',
      'body.template-product .fa-commerce-product-form .product-form__info-item--quantity{display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;align-items:center!important;gap:14px!important;min-height:64px!important;margin:8px 0 10px!important;padding:9px 11px 9px 13px!important;border:1px solid rgba(11,49,85,.22)!important;border-radius:14px!important;background:linear-gradient(135deg,rgba(255,255,255,.96),rgba(255,249,239,.88))!important;box-shadow:0 6px 16px rgba(8,39,67,.055),inset 0 1px 0 rgba(255,255,255,.96)!important}',
      'body.template-product .fa-commerce-product-form .product-form__info-item--quantity .product-form__info-title{min-width:0!important;margin:0!important;color:#152b40!important;font-size:12px!important;font-weight:850!important;letter-spacing:.035em!important;text-transform:uppercase!important}',
      'body.template-product .fa-commerce-product-form .product-form__info-item--quantity .product-form__info-content{display:flex!important;align-items:center!important;justify-content:flex-end!important;gap:8px!important;margin:0!important}',
      '.template-product .fa-quantity-native-select{display:none!important}',
      'body.template-product .fa-commerce-product-form .fa-quantity-selector,body.template-product .fa-commerce-product-form .fa-length-selector{display:grid!important;grid-template-columns:42px 62px 42px!important;width:auto!important;height:46px!important;overflow:hidden!important;border:1px solid rgba(11,49,85,.30)!important;border-radius:11px!important;background:#fffdf9!important;box-shadow:0 0 0 3px rgba(127,23,53,.025),0 3px 9px rgba(8,39,67,.055)!important}',
      'body.template-product .fa-commerce-product-form .fa-quantity-selector button,body.template-product .fa-commerce-product-form .fa-length-selector button{display:flex!important;align-items:center!important;justify-content:center!important;width:42px!important;height:44px!important;padding:0!important;border:0!important;background:rgba(11,49,85,.045)!important;color:#0b3155!important;font-size:20px!important;cursor:pointer!important}',
      'body.template-product .fa-commerce-product-form .fa-quantity-selector button:hover:not(:disabled),body.template-product .fa-commerce-product-form .fa-length-selector button:hover:not(:disabled){background:rgba(11,49,85,.09)!important}',
      'body.template-product .fa-commerce-product-form .fa-quantity-selector button:first-child,body.template-product .fa-commerce-product-form .fa-length-selector button:first-child{border-right:1px solid rgba(19,44,68,.12)!important}',
      'body.template-product .fa-commerce-product-form .fa-quantity-selector button:last-child,body.template-product .fa-commerce-product-form .fa-length-selector button:last-child{border-left:1px solid rgba(19,44,68,.12)!important}',
      'body.template-product .fa-commerce-product-form .fa-quantity-selector input,body.template-product .fa-commerce-product-form .fa-length-selector input{width:62px!important;height:44px!important;padding:0!important;border:0!important;background:#fffdf9!important;color:#132c44!important;font-size:16px!important;font-weight:850!important;text-align:center!important;-moz-appearance:textfield!important;appearance:textfield!important}',
      '.template-product .fa-quantity-selector input::-webkit-inner-spin-button,.template-product .fa-quantity-selector input::-webkit-outer-spin-button{-webkit-appearance:none!important;margin:0!important}',
      '.template-product .fa-product-quantity-unit,.template-product .fa-length-selector__unit{margin:0!important;color:#53677a!important;font-size:13px!important;font-weight:850!important}',
      'body.template-product .fa-commerce-product-form .fa-length-control .product-form__info-content{display:grid!important;justify-items:end!important}',
      '.template-product .fa-length-selector__interactive{display:flex!important;align-items:center!important;gap:8px!important}',
      '.template-product .product-form__payment-container>.fa-product-extras{margin:12px 0 0!important;padding:12px 0 0!important;border-top:1px solid rgba(11,49,85,.1)!important}',
      '.template-product .fa-product-extras__row{display:grid!important;grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:8px!important}',
      '.template-product .fa-product-extras__row .fa-extra-card{grid-column:auto!important;min-height:76px!important;padding:9px!important;border-radius:12px!important}',
      '.template-product [data-fa-extra="thread"]{order:1!important}',
      '.template-product [data-fa-extra="twenty"]{order:2!important}',
      '.template-product [data-fa-extra="half"]{order:3!important}',
      '.template-product .variant-swatch__item img{display:block!important;visibility:visible!important;opacity:1!important;width:100%!important;height:100%!important;object-fit:cover!important;object-position:center center!important;border-radius:50%!important}',
      'body.template-product .fa-commerce-product-form .color-swatch__item{background-size:cover!important;background-position:center center!important;background-repeat:no-repeat!important;background-color:#f5f2ec!important}',
      'body.template-product .fa-commerce-product-form .variant-swatch__item .aspect-ratio{background:#f5f2ec!important}',
      '.template-product .product-meta__sku-label{margin-right:3px!important;color:#344e66!important;font-weight:850!important}',
      'body.template-product .product-meta__share-buttons.hidden-phone{position:static!important;inset:auto!important;display:inline-flex!important;width:auto!important;margin:12px 0 0!important;padding:5px 7px!important;align-items:center!important;justify-content:flex-start!important;gap:8px!important;border:1px solid rgba(11,49,85,.10)!important;border-radius:999px!important;background:rgba(255,255,255,.72)!important;box-shadow:0 3px 10px rgba(8,39,67,.045)!important;transform:none!important}',
      'body.template-product .product-meta__share-buttons.hidden-phone:before{content:"Share";padding-left:4px;color:#53677a;font-size:10px;font-weight:850;letter-spacing:.06em;text-transform:uppercase}',
      'html[lang^="bg"] body.template-product .product-meta__share-buttons.hidden-phone:before{content:"Сподели"}',
      'body.template-product .product-meta__share-buttons .social-media__item-list{position:static!important;display:flex!important;margin:0!important;padding:0!important;align-items:center!important;gap:5px!important;transform:none!important}',
      'body.template-product .product-meta__share-buttons .social-media__item{position:static!important;display:block!important;margin:0!important;transform:none!important}',
      'body.template-product .product-meta__share-buttons .social-media__item a{position:static!important;display:grid!important;width:30px!important;height:30px!important;padding:0!important;place-items:center!important;border:1px solid rgba(11,49,85,.12)!important;border-radius:50%!important;background:#fffdf9!important;color:#0b3155!important;line-height:1!important;transform:none!important}',
      'body.template-product .product-meta__share-buttons .social-media__item a:hover{border-color:rgba(127,23,53,.35)!important;background:rgba(127,23,53,.06)!important;color:#8f102b!important}',
      'body.template-product .product-meta__share-buttons .social-media__item svg{position:static!important;display:block!important;width:14px!important;height:14px!important;margin:0!important;transform:none!important;fill:currentColor!important}',
      '}',
      '@media (min-width:801px) and (max-width:1080px){body.template-product .fa-commerce-product-form .color-swatch-list--large,body.template-product .fa-commerce-product-form .variant-swatch-list{grid-template-columns:repeat(6,minmax(0,1fr))!important}body.template-product .fa-commerce-product-form .color-swatch,body.template-product .fa-commerce-product-form .variant-swatch{width:46px!important;height:46px!important;min-width:46px!important}body.template-product .fa-commerce-product-form .color-swatch__item,body.template-product .fa-commerce-product-form .variant-swatch__item{width:42px!important;height:42px!important;min-width:42px!important;min-height:42px!important}.template-product .fa-product-extras__row{grid-template-columns:repeat(2,minmax(0,1fr))!important}.template-product [data-fa-extra="thread"]{grid-column:1/-1!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function productData(section) {
    var node = section.querySelector('[data-product-json]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function selectedVariant(section, data) {
    if (!data || !data.product || !data.product.variants) return null;
    var idInput = section.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = String(idInput ? idInput.value : data.selected_variant_id || '');
    for (var i = 0; i < data.product.variants.length; i++) {
      if (String(data.product.variants[i].id) === id) return data.product.variants[i];
    }
    return data.product.variants[0] || null;
  }

  function syncSku(section, suppliedVariant) {
    var reference = section.querySelector('.product-meta__reference');
    if (!reference) return;
    var variant = suppliedVariant || selectedVariant(section, productData(section));
    var value = variant && variant.sku ? String(variant.sku).trim() : '';
    var sku = reference.querySelector('.product-meta__sku');
    if (!sku) {
      sku = document.createElement('span');
      sku.className = 'product-meta__sku';
      sku.innerHTML = '<span class="product-meta__sku-label">SKU:</span> <span class="product-meta__sku-number"></span>';
      reference.appendChild(sku);
    }
    sku.querySelector('.product-meta__sku-number').textContent = value;
    sku.hidden = !value;
  }

  function restoreSwatches(section) {
    Array.prototype.forEach.call(section.querySelectorAll('.color-swatch__item'), function (item) {
      var image = item.style.backgroundImage;
      var color = item.style.backgroundColor;
      if (image && image !== 'none') item.style.setProperty('background-image', image, 'important');
      if (color) item.style.setProperty('background-color', color, 'important');
    });
  }

  function enhanceQuantity(section) {
    Array.prototype.forEach.call(section.querySelectorAll('.product-form__info-item--quantity:not(.fa-length-control)'), function (item) {
      var content = item.querySelector('.product-form__info-content');
      var select = item.querySelector('select[name="quantity"]');
      if (!content || !select) return;

      var wrapper = select.closest('.select-wrapper');
      (wrapper || select).classList.add('fa-quantity-native-select');

      Array.prototype.forEach.call(content.children, function (child) {
        if (child === wrapper || child === select || child.classList.contains('fa-quantity-selector')) return;
        if (/metre\(s\)|meters?|metres?|^m$|^м$/i.test((child.textContent || '').trim())) {
          child.classList.add('fa-product-quantity-unit');
          child.removeAttribute('style');
          child.textContent = isBg ? 'м' : 'm';
        }
      });

      if (content.querySelector('.fa-quantity-selector')) return;

      var box = document.createElement('div');
      var minus = document.createElement('button');
      var input = document.createElement('input');
      var plus = document.createElement('button');
      box.className = 'fa-quantity-selector';
      minus.type = plus.type = 'button';
      minus.textContent = '−';
      plus.textContent = '+';
      input.type = 'number';
      input.min = '1';
      input.step = '1';
      input.inputMode = 'numeric';
      minus.setAttribute('aria-label', isBg ? 'Намали количеството' : 'Decrease quantity');
      plus.setAttribute('aria-label', isBg ? 'Увеличи количеството' : 'Increase quantity');
      input.setAttribute('aria-label', isBg ? 'Количество' : 'Quantity');
      box.appendChild(minus);
      box.appendChild(input);
      box.appendChild(plus);
      content.insertBefore(box, wrapper || select);

      function setQuantity(raw, fire) {
        var amount = Math.min(999, Math.max(1, parseInt(raw, 10) || 1));
        var found = false;
        for (var i = 0; i < select.options.length; i++) {
          if (String(select.options[i].value) === String(amount)) { found = true; break; }
        }
        if (!found) {
          var option = document.createElement('option');
          option.value = option.textContent = String(amount);
          select.appendChild(option);
        }
        select.value = input.value = String(amount);
        minus.disabled = amount <= 1;
        if (fire) {
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      minus.addEventListener('click', function () { setQuantity((parseInt(input.value, 10) || 1) - 1, true); });
      plus.addEventListener('click', function () { setQuantity((parseInt(input.value, 10) || 1) + 1, true); });
      input.addEventListener('change', function () { setQuantity(input.value, true); });
      input.addEventListener('blur', function () { setQuantity(input.value, true); });
      select.addEventListener('change', function () { setQuantity(select.value, false); });
      setQuantity(select.value, false);
    });
  }

  function normalizeGallery(section) {
    var raw = section.getAttribute('data-section-settings');
    if (raw) {
      try {
        var settings = JSON.parse(raw);
        settings.enableImageZoom = false;
        settings.infoOverflowScroll = false;
        settings.galleryTransitionEffect = 'slide';
        section.setAttribute('data-section-settings', JSON.stringify(settings));
      } catch (error) {}
    }

    Array.prototype.forEach.call(section.querySelectorAll('.product-gallery__carousel--zoomable'), function (node) {
      node.classList.remove('product-gallery__carousel--zoomable');
    });
    Array.prototype.forEach.call(section.querySelectorAll('.product-gallery__zoom-notice, .product__zoom-wrapper'), function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });

    Array.prototype.forEach.call(section.querySelectorAll('.product-gallery__carousel-item[data-media-type="image"] .fa-product-gallery__media'), function (media) {
      [['position','relative'],['width','100%'],['height','0'],['padding-bottom','100%'],['overflow','hidden']].forEach(function (pair) {
        media.style.setProperty(pair[0], pair[1], 'important');
      });
      var image = media.querySelector('.product-gallery__image');
      if (!image) return;
      image.removeAttribute('data-zoom');
      [['position','absolute'],['inset','0'],['width','100%'],['height','100%'],['max-width','none'],['max-height','none'],['margin','0'],['object-fit','cover'],['object-position','center'],['transform','none'],['transform-origin','center'],['pointer-events','none']].forEach(function (pair) {
        image.style.setProperty(pair[0], pair[1], 'important');
      });
    });

    if (section.__faGalleryGuard) return;

    function repair(event) {
      var target = event.target;
      if (!target || !target.closest) return false;
      var item = target.closest('.product-gallery__carousel-item[data-media-type="image"]');
      if (!item || !section.contains(item)) return false;
      normalizeGallery(section);
      window.requestAnimationFrame(function () { normalizeGallery(section); });
      return true;
    }

    section.addEventListener('pointerdown', repair, true);
    section.addEventListener('pointerup', repair, true);
    section.addEventListener('click', function (event) {
      if (!repair(event)) return;
      event.preventDefault();
      event.stopPropagation();
      window.setTimeout(function () { normalizeGallery(section); }, 80);
    }, true);
    section.__faGalleryGuard = true;
  }

  function enhance(section, variant) {
    if (!section) return;
    normalizeGallery(section);
    syncSku(section, variant);
    restoreSwatches(section);
    enhanceQuantity(section);
  }

  function enhanceAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="product"]'), function (section) {
      enhance(section, null);
    });
  }

  installStyles();
  enhanceAll();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceAll);
  document.addEventListener('variant:changed', function (event) {
    var section = event.target && event.target.closest ? event.target.closest('[data-section-type="product"]') : document.querySelector('[data-section-type="product"]');
    var variant = event.detail && event.detail.variant ? event.detail.variant : null;
    window.requestAnimationFrame(function () { enhance(section, variant); });
    window.setTimeout(function () { enhance(section, variant); }, 120);
  });
  document.addEventListener('shopify:section:load', function () { window.setTimeout(enhanceAll, 0); });
  window.setTimeout(enhanceAll, 300);
})();


/* Desktop swatches: balanced, centred mobile-style rendering. */
(function faDesktopSwatchHardReset() {
  'use strict';

  var desktopQuery = window.matchMedia('(min-width: 801px)');
  var listSelector = '.product-form__variants .color-swatch-list--large, .product-form__variants .variant-swatch-list';
  var wrapperSelector = '.color-swatch, .variant-swatch';
  var itemSelector = '.color-swatch__item, .variant-swatch__item';

  function setImportant(element, property, value) {
    element.style.setProperty(property, value, 'important');
  }

  function resetDesktopPrice() {
    document.querySelectorAll('[data-fa-product-price-list]').forEach(function (priceList) {
      var currentPrice = priceList.querySelector('.price--highlight') || priceList.querySelector('.price:not(.price--compare)');
      var unit = priceList.querySelector('.fa-product-price-unit');
      var comparePrice = priceList.querySelector('.price--compare');

      if (!currentPrice || !unit) return;

      setImportant(priceList, 'display', 'flex');
      setImportant(priceList, 'align-items', 'baseline');
      setImportant(priceList, 'justify-content', 'flex-start');
      setImportant(priceList, 'flex-wrap', 'wrap');
      setImportant(priceList, 'column-gap', '0');
      setImportant(priceList, 'row-gap', '5px');

      setImportant(currentPrice, 'order', '1');
      setImportant(currentPrice, 'flex', '0 0 auto');
      setImportant(currentPrice, 'margin', '0');

      setImportant(unit, 'order', '2');
      setImportant(unit, 'display', 'inline-block');
      setImportant(unit, 'position', 'static');
      setImportant(unit, 'width', 'auto');
      setImportant(unit, 'flex', '0 0 auto');
      setImportant(unit, 'margin', '0 0 0 8px');
      setImportant(unit, 'white-space', 'nowrap');
      setImportant(unit, 'transform', 'none');

      if (comparePrice) {
        setImportant(comparePrice, 'order', '3');
        setImportant(comparePrice, 'flex', '0 0 auto');
        setImportant(comparePrice, 'position', 'static');
        setImportant(comparePrice, 'margin', '0 0 0 7px');
        setImportant(comparePrice, 'padding', '4px 9px');
        setImportant(comparePrice, 'border-radius', '999px');
        setImportant(comparePrice, 'background', 'rgba(127, 23, 53, 0.19)');
        setImportant(comparePrice, 'border', '1px solid rgba(127, 23, 53, 0.48)');
        setImportant(comparePrice, 'box-shadow', 'inset 0 0 0 1px rgba(255, 255, 255, 0.58)');
        setImportant(comparePrice, 'color', '#4f172b');
        setImportant(comparePrice, 'font-size', '16px');
        setImportant(comparePrice, 'font-weight', '850');
        setImportant(comparePrice, 'line-height', '1.15');
        setImportant(comparePrice, 'opacity', '1');
        setImportant(comparePrice, 'text-decoration-line', 'line-through');
        setImportant(comparePrice, 'text-decoration-color', '#a20f3c');
        setImportant(comparePrice, 'text-decoration-thickness', '2.5px');
        setImportant(comparePrice, 'text-decoration-skip-ink', 'none');
      }
    });
  }

  function resetDesktopSwatches() {
    if (!desktopQuery.matches || !document.body.classList.contains('template-product')) return;

    document.querySelectorAll(listSelector).forEach(function (list) {
      setImportant(list, 'display', 'grid');
      setImportant(list, 'width', 'fit-content');
      setImportant(list, 'max-width', '100%');
      setImportant(list, 'box-sizing', 'border-box');
      setImportant(list, 'grid-template-columns', 'repeat(7, 58px)');
      setImportant(list, 'grid-auto-flow', 'row');
      setImportant(list, 'align-items', 'center');
      setImportant(list, 'justify-items', 'center');
      setImportant(list, 'justify-content', 'start');
      setImportant(list, 'column-gap', '14px');
      setImportant(list, 'row-gap', '14px');
      setImportant(list, 'margin', '0');
      setImportant(list, 'padding', '14px 16px 16px');
      setImportant(list, 'overflow', 'visible');
      setImportant(list, 'border', '1px solid rgba(11, 49, 85, 0.08)');
      setImportant(list, 'border-radius', '16px');
      setImportant(list, 'background', 'linear-gradient(135deg, rgba(11, 49, 85, 0.05), rgba(157, 21, 63, 0.035))');
      setImportant(list, 'box-shadow', 'inset 0 1px 0 rgba(255, 255, 255, 0.58)');

      list.querySelectorAll(wrapperSelector).forEach(function (wrapper) {
        setImportant(wrapper, 'display', 'block');
        setImportant(wrapper, 'flex', 'none');
        setImportant(wrapper, 'width', '58px');
        setImportant(wrapper, 'min-width', '58px');
        setImportant(wrapper, 'max-width', '58px');
        setImportant(wrapper, 'height', '54px');
        setImportant(wrapper, 'min-height', '54px');
        setImportant(wrapper, 'max-height', '54px');
        setImportant(wrapper, 'margin', '0');
      });

      list.querySelectorAll(itemSelector).forEach(function (item) {
        setImportant(item, 'position', 'relative');
        setImportant(item, 'display', 'block');
        setImportant(item, 'width', '50px');
        setImportant(item, 'min-width', '50px');
        setImportant(item, 'max-width', '50px');
        setImportant(item, 'height', '50px');
        setImportant(item, 'min-height', '50px');
        setImportant(item, 'max-height', '50px');
        setImportant(item, 'margin', '2px');
        setImportant(item, 'padding', '0');
        setImportant(item, 'overflow', 'hidden');
        setImportant(item, 'border-radius', '50%');
        setImportant(item, 'background-position', 'center center');
        setImportant(item, 'background-repeat', 'no-repeat');
        setImportant(item, 'background-size', 'cover');
        setImportant(item, 'image-rendering', 'auto');
        setImportant(item, 'transform', 'none');

        item.querySelectorAll('.aspect-ratio, img').forEach(function (media) {
          setImportant(media, 'width', '100%');
          setImportant(media, 'height', '100%');
          setImportant(media, 'max-width', 'none');
          setImportant(media, 'max-height', 'none');
          setImportant(media, 'margin', '0');
          setImportant(media, 'padding', '0');
          setImportant(media, 'border-radius', '50%');
          setImportant(media, 'object-fit', 'cover');
          setImportant(media, 'object-position', 'center center');
          setImportant(media, 'image-rendering', 'auto');
          setImportant(media, 'transform', 'none');
        });
      });
    });

    resetDesktopPrice();
  }

  function queueReset() {
    window.requestAnimationFrame(resetDesktopSwatches);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetDesktopSwatches, { once: true });
  } else {
    resetDesktopSwatches();
  }

  document.addEventListener('variant:changed', queueReset);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest('.product-form__variants')) queueReset();
  });

  var productForm = document.querySelector('.fa-commerce-product-form, .product-form');
  if (productForm && window.MutationObserver) {
    new MutationObserver(queueReset).observe(productForm, { childList: true, subtree: true });
  }
})();
